__turbopack_context__.v({
  "bottom": "styles-module-scss-module__OqgwYG__bottom",
  "graduation": "styles-module-scss-module__OqgwYG__graduation",
  "graduationsContainer": "styles-module-scss-module__OqgwYG__graduationsContainer",
  "label": "styles-module-scss-module__OqgwYG__label",
  "labelContainer": "styles-module-scss-module__OqgwYG__labelContainer",
  "slider": "styles-module-scss-module__OqgwYG__slider",
  "sliderWrapper": "styles-module-scss-module__OqgwYG__sliderWrapper",
  "tick": "styles-module-scss-module__OqgwYG__tick",
  "tickLabel": "styles-module-scss-module__OqgwYG__tickLabel",
  "tickLabelContainer": "styles-module-scss-module__OqgwYG__tickLabelContainer",
  "top": "styles-module-scss-module__OqgwYG__top",
  "value": "styles-module-scss-module__OqgwYG__value",
});
